import './index.scss'

$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
// $(".nav li").hover(function(){
//     $(".header-bg").show()
//     $(this).find(".navchild").css("display","flex");
// },function(){
//     $(".header-bg").hide()
//     $(this).find(".navchild").css("display","none");
// })
// $(".nav li:first").hover(function(){
//     $(".header-bg").hide()
// })
// $(".nav li:last").hover(function(){
//     $(".header-bg").hide()
// })
// $(".mob-nav .nLi").click(function() {
//     $(this).find(".sub").slideToggle();
//     $(this).toggleClass("active");
// })

//滚动定位
$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {
            var targetOffset = $(location.hash).offset().top;
        console.log(targetOffset)
            $('html, body').animate({
                scrollTop: targetOffset - 98
            }, 500);
        }, 10);
    }
});
  